module.exports = __webpack_public_path__ + "img/6.89f866d6.png";